export function ViralScorecardIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 8l4 8h8l-6 6 2 8-8-4-8 4 2-8-6-6h8z" />
      <path d="M14 36l4-4" />
      <path d="M34 36l-4-4" />
      <path d="M24 36v-4" />
    </svg>
  );
}
